module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-Hairline-82a6d2bf11fc3f2f62bce53112d1d49e.otf";